// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__YSXzY","sticky":"panel_sticky__ldu4f"};